import { useFormContext } from "react-hook-form";
import { BasicInput } from "../../../components/BasicInput";
import { Button } from "../../../components/ui/button";
import { useStepValidation } from "../components/useStepValidation";
import { RegisterFormData } from "../components/types";

interface RegisterPasswordProps {
  onNext: () => void;
  onBack: () => void;
}

const RegisterPassword = ({ onNext, onBack }: RegisterPasswordProps) => {
  const {
    register,
    formState: { errors, touchedFields, isSubmitted },
  } = useFormContext<RegisterFormData>();

  const isValid = useStepValidation("password");

  const onSubmit = () => {
    onNext();
  };

  const getError = (field: keyof RegisterFormData["passwordInfo"]) => {
    return touchedFields.passwordInfo?.[field] || isSubmitted
      ? (errors.passwordInfo?.[field]?.message as string)
      : undefined;
  };

  return (
    <div className="flex flex-col gap-4 sm:gap-6 text-black03">
      <div className="text-center sm:text-left">
        <h2 className="text-xl sm:text-2xl font-semibold">Senha</h2>
        <p className="text-xs sm:text-sm text-black03 mt-1">
          Crie uma senha segura para sua conta
        </p>
      </div>

      <form className="flex flex-col gap-4 sm:gap-6">
        <div className="rounded-lg border border-gray-200 bg-gray-50 p-3 sm:p-4">
          <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
            Sua senha deve conter no mínimo 8 caracteres, incluindo letras
            maiúsculas, minúsculas, números e caracteres especiais.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          <BasicInput
            label="Senha"
            isPassword
            {...register("passwordInfo.password")}
            error={getError("password")}
            placeholder="Digite sua senha"
          />

          <BasicInput
            label="Confirmar senha"
            isPassword
            {...register("passwordInfo.confirmPassword")}
            error={getError("confirmPassword")}
            placeholder="Confirme sua senha"
          />
        </div>

        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mt-2">
          <Button
            type="button"
            variant="outline"
            onClick={onBack}
            className="h-11 sm:h-12 flex-1 order-2 sm:order-1 text-sm sm:text-base"
          >
            Voltar
          </Button>

          <Button
            type="button"
            disabled={!isValid}
            onClick={onSubmit}
            className="h-11 sm:h-12 flex-1 bg-primary text-white hover:bg-primary/90 order-1 sm:order-2 text-sm sm:text-base"
          >
            Continuar
          </Button>
        </div>
      </form>
    </div>
  );
};

export default RegisterPassword;
